// Styled components
import styled from 'styled-components';
import Color from 'constants/color';
import { Card, Pagination, Radio, Tag } from 'antd';

export const StyledPagination = styled(Pagination)`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: #ffffff;
  border-radius: 12px;
  padding: 12px 24px;
  margin: 30px auto;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  width: fit-content;

  .ant-pagination-item {
    border-radius: 50%;
    border: 1px solid #e0f7fa;
    background-color: #f9fdfc;
    color: #344054;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .ant-pagination-item a {
    color: #344054;
  }

  .ant-pagination-item-active {
    background-color: #20c997;
    border-color: #20c997;
  }

  .ant-pagination-item-active a {
    color: #ffffff;
    font-weight: 600;
  }

  .ant-pagination-item:hover {
    border-color: #0a6ee1;
  }

  .ant-pagination-item:hover a {
    color: #0a6ee1;
  }

  .ant-pagination-prev,
  .ant-pagination-next {
    border-radius: 50%;
    border: none;
  }

  .ant-pagination-item-link {
    color: #20c997;
    transition: all 0.3s ease;

    &:hover {
      color: #0a6ee1;
    }
  }
`;

export const StyledCard = styled(Card)`
  margin: 12px;
  padding: 3px;
  cursor: pointer;
  border-radius: 12px;
  border: none;
  background: linear-gradient(145deg, #f8fdfc, #ffffff); // ขาวฟ้าเขียวอ่อนแบบหรู
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08); // ลึกขึ้นแต่ยังนุ่ม
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 6px 28px rgba(32, 201, 151, 0.25); // เงาเขียวอ่อนหรู
  }

  .ant-card-head {
    min-height: 36px;
    background-color: rgba(32, 201, 151, 0.08); // พื้นหัวเขียวโปร่ง
    border-radius: 12px 12px 0 0;
  }

  .ant-card-head-title {
    font-weight: 600;
    font-size: 15px;
    color: #14557b; // น้ำเงินเข้มหรู
    text-align: center;
  }

  .ant-card-body {
    padding: 16px;
    font-size: 14px;
    color: #344054; // เทาเข้มอ่านง่าย
    line-height: 1.6;
  }
`;

export const StyledTag = styled(Tag)<{ color?: string }>`
  margin: 4px;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 16px;
  border-radius: 999px;
  text-transform: capitalize;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;

  background: ${({ color }) =>
    color === 'greenDarken1' ? 'linear-gradient(135deg, #20C997, #A1E5C1)' : 'linear-gradient(135deg, #FF6258, #FFD1D1)'};

  color: #ffffff;
  box-shadow: 0 4px 12px ${({ color }) => (color === 'greenDarken1' ? 'rgba(32, 201, 151, 0.3)' : 'rgba(255, 98, 88, 0.3)')};

  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);

  &:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
    box-shadow: 0 6px 18px ${({ color }) => (color === 'greenDarken1' ? 'rgba(32, 201, 151, 0.4)' : 'rgba(255, 98, 88, 0.4)')};
  }
`;

export const PastelRadioGroup = styled(Radio.Group)`
  margin-left: 10px;

  && .ant-radio-wrapper {
    margin-right: 10px;
    background-color: #ffffff; // พื้นหลังขาวหรู
    border-radius: 24px;
    padding: 6px 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06); // ลึกนิด ๆ ดูพรีเมียม
    transition: all 0.3s ease;
    cursor: pointer;
  }

  && .ant-radio-wrapper .ant-radio-inner {
    width: 16px;
    height: 16px;
    border-color: #20c997; // ขอบสีเขียวหลัก
    background-color: #ffffff;
    background-image: linear-gradient(#ffffff, #ffffff), radial-gradient(circle at center, #a1e5c1, #e0fcf3);
    background-origin: border-box;
    background-clip: content-box, border-box;
    transition: all 0.3s ease;
  }

  && .ant-radio-wrapper .ant-radio + span {
    color: #344054; // สีเทาเข้มแบบอ่านง่าย
    font-size: 14px;
    font-weight: 500;
    transition: color 0.3s ease;
  }

  && .ant-radio-wrapper:hover {
    box-shadow: 0 0 0 2px rgba(10, 110, 225, 0.15); // แสงฟ้าเบาๆ
  }

  && .ant-radio-wrapper:hover .ant-radio-inner {
    border-color: #0a6ee1;
    background-color: #e0f7fa;
  }

  && .ant-radio-wrapper:hover .ant-radio-inner:after {
    background-color: #a1e5c1;
  }

  && .ant-radio-wrapper-checked {
    background-color: #e5f9ef; // พื้นเขียวอ่อนตอนเลือก
    box-shadow: 0 0 0 2px rgba(32, 201, 151, 0.3), 0 2px 12px rgba(32, 201, 151, 0.2);
  }

  && .ant-radio-wrapper-checked .ant-radio-inner {
    border-color: #20c997;
    background-color: #20c997;
    background-image: linear-gradient(#20c997, #20c997), radial-gradient(circle at center, #a1e5c1, #d4e9e2);
    box-shadow: 0 0 0 1px rgba(32, 201, 151, 0.5), 0 0 8px 3px rgba(161, 229, 193, 0.5);
  }

  && .ant-radio-wrapper-checked .ant-radio-inner:after {
    background-color: #ffffff;
    width: 8px;
    height: 8px;
    top: 4px;
    left: 4px;
  }
`;
